export { Hub } from 'aws-amplify/utils';

export { Authenticator } from './authenticator';
export {
  UserProperty,
  StoredUserAttributes,
  UserAttributes,
  UserNamedAttribute,
  AuthenticatorUser,
  AuthenticatorError
} from './types';

export { AmplifyAuthenticator, CognitoUser } from './amplify/amplify-authenticator';
export {
  transformAuth0User,
  TransformedAuth0User,
  isSageIDUser,
  isSXPManagedUser,
  isAuth0Authenticated,
  isSetupCompleted,
  deleteAuth0Cookies
} from './auth0/utils';
export { CurrentUserCheck } from './auth0/types';
export {
  AmplifyAuthConfig,
  AmplifyError,
  AmplifyErrorObject,
  AmplifyException,
  HostedUIIdentityProvider,
  HubPayload,
  HubCallback
} from './amplify/types';
